import { t, Trans } from '@lingui/macro';
import FormSection from '../../form/FormSection';
import { COLUMN_TYPES } from '../../data-table/DataTableColumns';
import { MaterialUiIcon } from '../../icon';
import ListSelectorField from '../../form/ListSelectorField';
import { SORT_ASC } from '../../../utilities/FormUtilities';
import { NAME_FIELD, TAGS_FIELD } from '../service-tests/ServiceTestAdminConstants';
import { SERVICE_TESTS_FIELD } from './BusinessServiceAdminConstants';
import { formatTags } from '../../../utilities/StringUtilities';

function buildServiceTestColumns() {
    return [
        {
            type: COLUMN_TYPES.ICON,
            title: t`Type`,
            mapping: 'testTypeObject',
            sortable: false,
            width: 74,
            csvFormatter: (value, row) => row?.testTypeObject?.details?.title,
            icons: [
                {
                    getIcon: (row) => <MaterialUiIcon icon={row?.testTypeObject?.details?.icon} />,
                    getTooltip: (row) => row?.testTypeObject?.details?.title,
                },
            ],
        },
        {
            type: COLUMN_TYPES.TEXT,
            title: t`Name`,
            sortable: true,
            mapping: NAME_FIELD,
            width: 250,
        },
        {
            type: COLUMN_TYPES.TEXT,
            mapping: TAGS_FIELD,
            title: t`Tags`,
            sortable: false,
            formatter: formatTags,
            width: 300,
        },
    ];
}

const selectedDataSource = {
    url: '/ipm/v1/admin/tests/findSelected',
    totalProperty: 'count',
    dataProperty: 'data',
    params: {
        searchFields: [NAME_FIELD, TAGS_FIELD],
    },
    initialSort: [{ property: NAME_FIELD, direction: SORT_ASC }],
};

const availableDataSource = {
    ...selectedDataSource,
    url: '/ipm/v1/admin/tests/findExcluded',
};

const idsDataSource = {
    params: selectedDataSource.params,
    url: '/ipm/v1/admin/tests/selectionUUIDs',
};

const initialSort = [{ property: NAME_FIELD, direction: SORT_ASC }];

const addButtonText = t`Add Service Tests`;
const emptyGridText = t`There are no Service Tests in this Business Service`;

export function BusinessServicesAdminTests({ formData, setAgentSelectionIsDirty }) {
    const columns = buildServiceTestColumns();

    return (
        <FormSection title={<Trans>Associated Service Tests</Trans>} addSpacer>
            <ListSelectorField
                gridColumns={columns}
                sorters={initialSort}
                dbSelected={formData[SERVICE_TESTS_FIELD]}
                selectedDataSource={selectedDataSource}
                availableDataSource={availableDataSource}
                idsDataSource={idsDataSource}
                fieldName={SERVICE_TESTS_FIELD}
                addButtonText={addButtonText}
                setSelectionIsDirty={setAgentSelectionIsDirty}
                isMultiRemove={false}
                selectedEmptyGridText={emptyGridText}
            />
        </FormSection>
    );
}
